<template>
    <div class="columns is-mobile is-centered has-background-primary p-2">
        <h1 class="title is-4 has-text-white"><i class="fas fa-arrow-right-from-bracket"></i> &nbsp; CLIENTE</h1>
    </div>

    <div class="box formcliente-box" @submit.prevent="" v-if="formAttivo">

        <div class="columns">
            <div class="column">
                <div class="field buttons">
                    <button class="button is-light" @click="bAnnulla" :disabled="!clienteDaAggiornare">Annulla</button>
                    <button class="button is-primary" @click="bSalva" :disabled="!clienteDaAggiornare">Salva</button>
                </div>                
            </div>
            <div class="column">
                <div class="field buttons is-right">
                    <button class="button is-danger" @click="bElimina" v-if="idClienteSelezionato!=-1 && permettiElimina">Elimina</button>
                </div>
            </div>
        </div>

        <div class="blocco-scroll">
        <div class="columns">
            <div class="column is-4">
                <CampoNumero @valoreCambiato="clienteModifica"
                    :key="chiaveRicarica"
                    :valore=clienteSelezionato.codice
                    formato="flat"
                    identificativo="codice"
                    etichetta="Codice"
                    tipo="Intero"/>
            </div>
            <div class="column is-4">
                <div class="field">
                    <label class="label">Nome</label>
                    <div class="control">
                        <input class="input" type="text" v-model="clienteSelezionato.nome"  @change="clienteModifica(clienteSelezionato.nome,'nome')">
                    </div>
                </div>
            </div>
            <div class="column is-4">
                <div class="field">
                    <label class="label">Cognome / Denominazione</label>
                    <div class="control">
                        <input class="input" type="text" v-model="clienteSelezionato.cognome"  @change="clienteModifica(clienteSelezionato.cognome, 'cognome')">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column is-4">
                <div class="field">
                    <label class="label">Residendaza / Sede legale</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Via" v-model="clienteSelezionato.indirizzo.via"  @change="clienteModifica(clienteSelezionato.indirizzo.via,'indirizzo.via')">
                    </div>
                </div>
            </div>
            <div class="column is-1">
                <div class="field">
                    <label class="label">&nbsp;</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Numero" v-model="clienteSelezionato.indirizzo.civico"  @change="clienteModifica(clienteSelezionato.indirizzo.civico,'indirizzo.civico')">
                    </div>
                </div>
            </div>
            <div class="column is-1">
                <div class="field">
                    <label class="label">&nbsp;</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="CAP" v-model="clienteSelezionato.indirizzo.cap"  @change="clienteModifica(clienteSelezionato.indirizzo.cap,'indirizzo.cap')">
                    </div>
                </div>
            </div>
            <div class="column is-3">
                <div class="field">
                    <label class="label">&nbsp;</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Città" v-model="clienteSelezionato.indirizzo.citta"  @change="clienteModifica(clienteSelezionato.indirizzo.citta,'indirizzo.citta')">
                    </div>
                </div>
            </div>
            <div class="column is-1">
                <div class="field">
                    <label class="label">&nbsp;</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Provincia" v-model="clienteSelezionato.indirizzo.provincia"  @change="clienteModifica(clienteSelezionato.indirizzo.provincia,'indirizzo.provincia')">
                    </div>
                </div>
            </div>
            <div class="column is-2">
                <div class="field">
                    <label class="label">&nbsp;</label>
                    <div class="control">
                        <input class="input" type="text" placeholder="Stato" v-model="clienteSelezionato.indirizzo.stato"  @change="clienteModifica(clienteSelezionato.indirizzo.stato,'indirizzo.stato')">
                    </div>
                </div>
            </div>
        </div>
        <div class="columns">
            <div class="column">
                <div class="field">
                    <label class="label">Note</label>
                    <div class="control">
                        <textarea class="textarea" placeholder="Note"  rows="3" v-model="clienteSelezionato.note"  @change="clienteModifica(clienteSelezionato.note, 'note')"></textarea>
                    </div>
                </div>
            </div>
        </div>

        <div class="tabs">
            <ul>
                <li :class="{'is-active': statoInterfaccia.formClienteTab == 1}">
                    <a @click="bSelezionaTAb(1)">
                        <span>Leads</span>
                    </a>
                </li>
                <li :class="{'is-active': statoInterfaccia.formClienteTab == 2}">
                    <a @click="bSelezionaTAb(2)">
                        <span>Lavori</span>
                    </a>
                </li>
            </ul>
        </div>

        <ElencoLeads
            :bottoneAggiungiVisibile=true
            :cliente=leggiInfoDB(clienteSelezionato).id
            :campoRicercaVisibile=false
            @elementoSelezionato="gestisciSelezioneElemento"
            :titolo-visibile="false"
            v-if="statoInterfaccia.formClienteTab==1 && leggiInfoDB(clienteSelezionato).id"/>
        <ElencoLavori
            :bottoneAggiungiVisibile=true
            :cliente=leggiInfoDB(clienteSelezionato).id
            :campoRicercaVisibile=false
            :titolo-visibile="false"
            @elementoSelezionato="gestisciSelezioneElemento"
            v-if="statoInterfaccia.formClienteTab==2 && leggiInfoDB(clienteSelezionato).id"/>
    </div>
    </div>
    <MessaggioModale @selezionato="bComandoModale"
        :confMessaggioModale=messaggioModale
        v-if="messaggioModale"/>
</template>

<script setup>
    import CampoNumero from "./CampoNumero.vue";
    import ElencoLeads from "./ElencoLeads.vue";
    import ElencoLavori from "./ElencoLavori.vue";
    import MessaggioModale from "./MessaggioModale.vue";
    // FIX: Importato nextTick (allineato a FormLead)
    import { defineProps, defineEmits, ref, watch, nextTick } from "vue";
    import { Timestamp } from "firebase/firestore"
    import { dbClienti, salvaClienteInFirestore, eliminaClienteInFirestore, leggiInfoDB, leggiInfoDBRaw, aggiungiInfoDB } from "./../code/gestioneDB";
    import { generaIdCliente, permettiElimina, statoInterfaccia, clonaOggetto } from "./../code/utilita";

    // PROPRIETA' ED EVENTI DEL COMPONENTE
    const props = defineProps({
        idCliente: {
            type: Number,
            default: -1
        }
    });
    const emit = defineEmits(['elementoSelezionato', 'modificaElementoInCorso']);

    // VARIABILI DEL COMPONENTE
    const clienteSelezionato = ref({});                 
    const clienteDaAggiornare = ref(null);              
    const messaggioModale = ref(null);                  
    const idClienteSelezionato = ref(props.idCliente || -1);
    const interfacciaBloccata = ref(false);
    const chiaveRicarica = ref(0);                      
    // FIX: Aggiunta variabile formAttivo per l'hard-reset (allineato a FormLead)
    const formAttivo = ref(true);

    // REATTIVITÀ: Protezione in caso di caricamenti asincroni o offline
    watch(() => props.idCliente, (nuovoId) => {
        idClienteSelezionato.value = nuovoId || -1;
        setupForm();
    });

    // SETUP DEL COMPONENTE
    setupForm();
    if (!statoInterfaccia.value.formClienteTab) {
        statoInterfaccia.value.formClienteTab = 1;
    }

    // FUNZIONI DEL COMPONENTE
    function setupForm() {
        chiaveRicarica.value++; 
        
        const id = idClienteSelezionato.value;

        const scheletroBase = {
            codice: null,
            indirizzo: {}, 
        };

        if (id == -1) {
            clienteSelezionato.value = { ...scheletroBase };
            
            aggiungiInfoDB(clienteSelezionato.value, {
                id: -1,
                leads: {},
                lavori: {}
            });
        } else {
            const clienteOriginale = dbClienti.value[id];
            
            if (clienteOriginale) {
                clienteSelezionato.value = { ...scheletroBase, ...clonaOggetto(clienteOriginale) };
                
                // FIX: Recuperiamo infoRaw assorbendo in modo sicuro leads e lavori. 
                // Evitiamo che spariscano dal clone in fase di conversione "Cold to Hot".
                const infoRaw = leggiInfoDBRaw(clienteOriginale) || { id: id, leads: {}, lavori: {} };
                aggiungiInfoDB(clienteSelezionato.value, infoRaw);
            } else {
                clienteSelezionato.value = { ...scheletroBase };
                aggiungiInfoDB(clienteSelezionato.value, { id: id, leads: {}, lavori: {} });
            }
        }
        clienteDaAggiornare.value = null;
        interfacciaBloccata.value = false;
    }

    function clienteModifica(valore, etichetta) {
        if (clienteDaAggiornare.value == null) {
            clienteDaAggiornare.value = {};
            bBloccaInterfaccia(true);
        }
        if (etichetta.includes('.')) {
            let etichette = etichetta.split('.');
            if (!clienteDaAggiornare.value[etichette[0]]) {
                clienteDaAggiornare.value[etichette[0]] = {};
            }
            clienteDaAggiornare.value[etichette[0]][etichette[1]] = valore;
        } else {
            clienteDaAggiornare.value[etichetta] = valore;
        }
    }

    function bAnnulla() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Cancella le modifiche', comando:'cancella'},
            messaggio:"Proseguendo perderai le modifiche fatte"
        };
    }

    function bSalva() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:{testo:'Salva', comando:'salva'},
            testoDanger:null,
            messaggio:"Vuoi salvare le modifiche al cliente?"
        };
    }

    function bElimina() {
        messaggioModale.value = {
            testoLight:{testo:'Annulla', comando:'annulla'},
            testoPrimary:null,
            testoDanger:{testo:'Elimina', comando:'elimina'},
            messaggio:"Vuoi eliminare il cliente?"
        };
    }

    async function bComandoModale(comando) {
        // FIX: Raggruppiamo i case in blocchi isolati ({ }) per placare ESLint come in FormLead
        switch (comando) {
            case 'annulla': {
                messaggioModale.value = null;
                break;
            }
            case 'cancella': {
                emit('modificaElementoInCorso', false);
                messaggioModale.value = null;
                setupForm();
                resetForm(); // FIX: Introdotto l'hard reset per svuotare componenti testardi
                break;
            }
            case 'salva': {
                if (idClienteSelezionato.value == -1) {
                    idClienteSelezionato.value = generaIdCliente();
                }
                aggiungiInfoDB(clienteDaAggiornare.value, {
                    id: idClienteSelezionato.value
                });
                await salvaClienteInFirestore(clienteDaAggiornare.value, Timestamp.now());
                
                messaggioModale.value = null;
                emit('modificaElementoInCorso', false);
                
                // FIX: Invece di fare solo setupForm, emettiamo la selezione. 
                // Permette ad App.vue di aggiornare l'URL/lo stato se siamo passati da -1 a un ID reale.
                emit('elementoSelezionato', {
                    tipo: 'cliente',
                    idCliente: idClienteSelezionato.value
                });
                break;
            }
            case 'elimina': {
                eliminaClienteInFirestore(idClienteSelezionato.value);
                emit('modificaElementoInCorso', false);
                emit('elementoSelezionato', {
                    tipo: 'clienti'
                });
                break;
            }
        }
    }

    function bSelezionaTAb(index) {
        statoInterfaccia.value.formClienteTab = index;
    }

    function gestisciSelezioneElemento(elementoSelezionato) {
        if (clienteDaAggiornare.value != null || interfacciaBloccata.value == true) {
            console.log('clienteDaAggiornare: ' + JSON.stringify(clienteDaAggiornare.value));
            console.log('interfacciaBloccata: ' + interfacciaBloccata.value);
            messaggioModale.value = {
                testoLight:{testo:'Ok', comando:'annulla'},
                testoPrimary:null,
                testoDanger:null,
                messaggio:"Per proseguire devi salvare o annullare le modifiche"
            };
        } else {
            emit('elementoSelezionato', elementoSelezionato);
        }
    }

    function bBloccaInterfaccia(stato) {
        interfacciaBloccata.value = stato;
        emit('modificaElementoInCorso', stato);
    }

    // FIX: Funzione di utilità ripresa da FormLead per l'hard-reset grafico
    async function resetForm() {
        formAttivo.value = false;
        await nextTick();
        formAttivo.value = true;
    }

</script>